import Autocomplete from "@tomickigrzegorz/autocomplete";
import geocoder from "../geocoder";
import { defaults, escape } from "../autocomplete";

export default ({ country = null, old = {} }) => ({
  country,
  selected: old,
  autocomplete: null,
  abortController: null,
  error: null,

  init() {
    const geocode = geocoder(true);

    this.$refs.input.value = this.selected.place_name || "";

    this.autocomplete = new Autocomplete(this.$refs.input.id, {
      ...defaults("address"),
      onSearch: async ({ currentValue }) => {
        this.abortController?.abort();

        this.abortController = new AbortController();
        this.error = null;

        try {
          const locations = await geocode(
            currentValue,
            {
              includeAddresses: true,
              includeStates: false,
            },
            this.abortController.signal,
          );

          return locations;
        } catch (error) {
          if (error.name === "AbortError") {
            return [];
          }

          console.error(error);
          this.error = error.message;
          return [];
        }
      },

      noResults: ({ template }) => {
        if (!this.error) {
          return template(
            `<div class="px-4 py-2 text-gray-600">No locations match your query.</div>`,
          );
        }

        return template(
          `<div class="px-4 py-2 text-gray-600">Something went wrong loading suggestions (${escape(this.error)}). Please try a different browser or disable browser extensions.</div>`,
        );
      },

      onSubmit: async ({ object }) => {
        this.selected = object;
      },
    });
  },

  destroy() {
    this.autocomplete?.destroy();
    this.abortController?.abort();
  },

  onBlur() {
    if (this.$refs.input.value !== (this.selected?.place_name || "")) {
      this.$refs.input.value = "";
      this.selected = {};
    }
  },
});
